import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnrollService, GlobalFunctionsService } from 'app/core/services';
import { Order } from 'app/shared/models';
import * as CryptoJS from 'crypto-js';

@Component({
  moduleId: module.id,
  selector: 'fo-order',
  template: ''
})
export class OrderPage implements OnInit {
  order: Order;

  constructor(
    private globalFunctionsService: GlobalFunctionsService,
    private enrollService: EnrollService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.globalFunctionsService.showBasket(false);
    this.globalFunctionsService.showTabs(false);
  }

  ngOnInit(): void {
    const orderParam = this.route.snapshot.paramMap.get('order');
    const orderWordArray = CryptoJS.enc.Base64.parse(orderParam);
    this.order = JSON.parse(orderWordArray.toString(CryptoJS.enc.Utf8));
    console.log(this.order);

    // Save Order
    this.enrollService
      .create(this.order)
      .then(() => {
        this.globalFunctionsService.updateOrder(this.order);
        this.globalFunctionsService.enableTabs(4);

        window.scrollTo(0, 0);
        this.router.navigate(['thanks'], { queryParamsHandling: 'merge' });
      })
      .catch(() => {
        this.globalFunctionsService.enableTabs(4);

        window.scrollTo(0, 0);
        this.router.navigate(['error'], { queryParamsHandling: 'merge' });
      });
  }
}
